import { render } from "./PlanInfo.vue?vue&type=template&id=5a439527&scoped=true&ts=true"
import script from "./PlanInfo.vue?vue&type=script&lang=ts"
export * from "./PlanInfo.vue?vue&type=script&lang=ts"

import "./PlanInfo.vue?vue&type=style&index=0&id=5a439527&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a439527"]])

export default __exports__